import React, { useState, useEffect } from "react";

// import PropTypes from "prop-types";
import { Link, useSearchParams } from "react-router-dom";
import styled from "styled-components";

// source
import ArrowBack from "../assets/icons/arrow_back.svg";
import { useTranslation } from "react-i18next";
import ImageSlider from "../components/ImageSlider";

import qrGuideImg01 from "../assets/img/guideQR01.jpg";
import qrGuideImg02 from "../assets/img/guideQR02.jpg";
const images = [qrGuideImg01, qrGuideImg02];

const TitleText = styled.div`
  color: #066aeb;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 29px; /* 120.833% */
`;

const BottomInfoText1 = styled.div`
  margin-top: 18px;
  color: #000;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;
const BottomInfoText2 = styled.div`
  margin-top: 10px;
  color: #515151;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
`;

const GuideQR = () => {
  const { t, i18n } = useTranslation();
  const endPoint = JSON.parse(sessionStorage.getItem("endPoint"));
  return (
    <div>
      <div
        style={{
          position: "fixed",
          display: "flex",

          zIndex: 1,
          top: 16,
          left: 16,
          inset: "auato 0 0 auto",
        }}
      >
        <Link to="/detail">
          <button
            style={{
              backgroundColor: "transparent",
              border: "none",
              padding: 0,
            }}
          >
            <img src={ArrowBack} alt="" />
          </button>
        </Link>
      </div>

      <div
        style={{
          height: "100%",
          backgroundColor: "white",
          padding: "26px",
          color: "#282D4B",
        }}
      >
        <div
          style={{
            padding: "38px 0 0 0",
          }}
        >
          <ImageSlider
            style={{
              display: "block",
              width: "100%",
              height: "80px",
              borderRadius: "8px",
            }}
            images={images}
          ></ImageSlider>
          <div
            style={{
              paddingTop: "20px",
            }}
          >
            <TitleText>
              <div>
                {endPoint.name[i18n.language]}
                {t("qrGuide.titleText1")}
              </div>
              <div>{t("qrGuide.titleText2")}</div>
            </TitleText>
          </div>
        </div>
        <div
          style={{
            padding: "0 0 0 0",
          }}
        >
          <BottomInfoText1>
            <div>{t("qrGuide.bottomInfoText1")}</div>
          </BottomInfoText1>
          <BottomInfoText2>
            <div>{t("qrGuide.bottomInfoText2")}</div>
            <div>{t("qrGuide.bottomInfoText2_1")}</div>
          </BottomInfoText2>
        </div>
      </div>
    </div>
  );
};

export default GuideQR;
